import React from "react";
import ReactDOM from "react-dom";
import each from "lodash/each";
import { Provider } from "mobx-react";
import ModelWalk from "../components/ModelWalk/ModelWalk";
import FeatureCards from "../components/FeatureCards";
import Accessories from "../components/Accessories";
import ColorPicker from "../components/ColorPicker";
import SubNav from "../components/SubNav";
import Reviews from "../components/Reviews";
import TechVideos from "../components/TechVideos";
import PromoBar from "../components/PromoBar";
import Gallery from "./Gallery";
import SpecsComparison from "./SpecsComparison";
import Stories from "./Stories";
import { Three60 } from "../components/Three60";
import { Highlights } from "../components/Highlights";
import { ModelCta } from "../components/ModelCta";
import HybridColorPicker from "../components/HybridColorPicker";
import ColorsStore from "../stores/ColorsStore";
import ModelPickerStore from "../stores/ModelPickerStore";
import BlockingPopupContainer from "./BlockingPopupContainer";

const ModelPage = () => {
  //SubNav
  const subNav = document.getElementById("subNav");
  if (subNav && window["SubNavOpts"]) {
    ReactDOM.render(<SubNav opts={window["SubNavOpts"]} />, subNav);
  }

  //Model Walk
  const modelWalk = document.getElementById("modelWalk");
  if (modelWalk) {
    const contentSrc = modelWalk.getAttribute("data-content");
    ReactDOM.render(
      <ModelWalk
        content={contentSrc ? window[contentSrc] : []}
        hidePriceDisclaimer={window["hidePriceDisclaimer"]}
        priceDisclaimerOverride={window["priceDisclaimerOverride"]}
        hideRepayment={false}
      />,
      modelWalk
    );
  }

  //Colour Picker
  const colourPicker = document.getElementById("colorPicker");
  if (colourPicker) {
    const contentSrc = colourPicker.getAttribute("data-content");

    const colorPickerRoot = (
      <Provider
        ColorsStore={new ColorsStore()}
        ModelPickerStore={new ModelPickerStore()}
      >
        <ColorPicker content={contentSrc ? window[contentSrc] : []} />
      </Provider>
    );

    ReactDOM.render(colorPickerRoot, colourPicker);
  }

  //Hybrid Colour Picker
  const hybridColorPicker = document.getElementById("hybridColorPicker");

  if (hybridColorPicker) {
    const contentSrc = hybridColorPicker.getAttribute("data-content");

    const hybridColorPickerRoot = (
      <Provider
        ColorsStore={new ColorsStore()}
        ModelPickerStore={new ModelPickerStore()}
      >
        <HybridColorPicker content={contentSrc ? window[contentSrc] : []} />
      </Provider>
    );

    ReactDOM.render(hybridColorPickerRoot, hybridColorPicker);
  }

  //Gallery
  const gallery = document.getElementById("gallery");
  if (gallery) {
    const contentSrc = gallery.getAttribute("data-content");
    const fullGalleryMode =
      gallery.getAttribute("data-fullGalleryMode") === "true";
    ReactDOM.render(
      <Gallery
        content={contentSrc ? window[contentSrc] : []}
        fullGalleryMode={fullGalleryMode ? true : false}
      />,
      gallery
    );
  }

  //FeatureCards
  each(document.querySelectorAll(".featureCards"), (cardElement) => {
    const contentSrc = cardElement.getAttribute("data-content");
    const itemClass = cardElement.getAttribute("data-itemClass");
    ReactDOM.render(
      <FeatureCards
        content={contentSrc ? window[contentSrc] : []}
        itemClassName={itemClass || null}
      />,
      cardElement
    );
  });

  //AccessoriesPage
  const fullAccessories = document.getElementById("fullAccessories");
  if (fullAccessories) {
    const contentSrc = fullAccessories.getAttribute("data-content");
    ReactDOM.render(
      <Accessories content={contentSrc ? window[contentSrc] : []} />,
      fullAccessories
    );
  }

  //SpecsComparisonPage
  const fullSpecs = document.getElementById("fullSpecs");
  if (fullSpecs) {
    const contentSrc = fullSpecs.getAttribute("data-content");
    const fullSpecsDisclaimer = document.getElementById("fullSpecsDisclaimer");

    if (fullSpecsDisclaimer) {
      const fullSpecsContent = fullSpecsDisclaimer.getAttribute("data-content");
      ReactDOM.render(
        <SpecsComparison
          content={contentSrc ? window[contentSrc] : []}
          specsAndFeaturesDisclaimer={fullSpecsContent}
        />,
        fullSpecs
      );
    } else {
      ReactDOM.render(
        <SpecsComparison
          content={contentSrc ? window[contentSrc] : []}
          specsAndFeaturesDisclaimer={""}
        />,
        fullSpecs
      );
    }
  }

  //Articles
  const articles = document.getElementById("articles-content");
  if (articles) {
    const contentSrc = articles.getAttribute("data-content");
    const itemClass = articles.getAttribute("data-itemClass");
    ReactDOM.render(
      <FeatureCards
        content={contentSrc ? window[contentSrc] : []}
        itemClassName={itemClass || null}
        hiddenFullTextHtml={true}
      />,
      articles
    );
  }

  //Reviews
  const reviews = document.getElementById("reviews-content");
  if (reviews) {
    const contentSrc = reviews.getAttribute("data-content");
    ReactDOM.render(
      <Reviews content={contentSrc ? window[contentSrc] : []} />,
      reviews
    );
  }

  //Stories
  const stories = document.getElementById("stories");
  if (stories) {
    const baseName = stories.getAttribute("data-baseName");
    if (baseName) ReactDOM.render(<Stories baseName={baseName} />, stories);
  }

  //Section Videos
  const sectionVideos = document.getElementsByClassName("sectionVideos");
  if (sectionVideos) {
    const videos = [].slice.call(sectionVideos);
    videos.forEach((video) => {
      const contentSrc = video.getAttribute("data-content");
      ReactDOM.render(
        <TechVideos content={contentSrc ? window[contentSrc] : []} />,
        video
      );
    });
  }

  const blockingPopup = document.getElementById("blockingPopup");
  if (blockingPopup) {
    ReactDOM.render(<BlockingPopupContainer />, blockingPopup);
  }

  Three60();
  Highlights();
  // ModelCta();
  PromoBar();
};

export default ModelPage;
